export function resolveMountingSelectionAmount(
  selectedIdentifier: string | undefined,
  optionIdentifier: string,
): number {
  return selectedIdentifier === optionIdentifier ? 0 : 1;
}
